import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SearchSettings {
    VOC: string;
    mcsType = 3;
}
